/* PRELOAD */

var path = './dist/images/',
arrayOfImages = [];
arrayOfImages[0] = path+'start/pozadi-uvod.png';
arrayOfImages[1] = path+'start/start-menu-1.png';
arrayOfImages[2] = path+'start/start-menu-2.png';
arrayOfImages[3] = path+'start/start-menu-3.png';
arrayOfImages[4] = path+'start/start-menu-4.png';
arrayOfImages[5] = path+'start/start-nadpis.png';
arrayOfImages[6] = path+'slide1/bg-system.jpg';
arrayOfImages[7] = path+'slide1/btn_znovu.png';
arrayOfImages[8] = path+'slide1/btn_zpet.png';
arrayOfImages[9] = path+'slide1/kapka_no.png';
arrayOfImages[10] = path+'slide1/kapka_ok.png';
arrayOfImages[11] = path+'slide1/listecek1.png';
arrayOfImages[12] = path+'slide1/listecek2.png';
arrayOfImages[13] = path+'slide1/listecek3.png';
arrayOfImages[14] = path+'slide1/listecek4.png';
arrayOfImages[15] = path+'slide1/listecek5.png';
arrayOfImages[16] = path+'slide1/listecek6.png';
arrayOfImages[17] = path+'slide1/listecek7.png';
arrayOfImages[18] = path+'slide1/listecek8.png';
arrayOfImages[19] = path+'slide3/list13/ot_13_3.png';
arrayOfImages[20] = path+'slide1/listecek9.png';
arrayOfImages[21] = path+'slide1/listecek10.png';
arrayOfImages[22] = path+'slide1/listecek11.png';
arrayOfImages[23] = path+'slide1/listecek12.png';
arrayOfImages[24] = path+'slide1/otaznik_47x47.png';
arrayOfImages[25] = path+'slide1/place_ok.png';
arrayOfImages[26] = path+'slide1/pozadi-nalepky.png';
arrayOfImages[27] = path+'slide1/start-box1.png';
arrayOfImages[28] = path+'slide1/start-btn.png';
arrayOfImages[29] = path+'slide1/start-pohyb.png';
arrayOfImages[30] = path+'slide2/banner_sipka2.png';
arrayOfImages[31] = path+'slide2/banner_sipka3.png';
arrayOfImages[32] = path+'slide2/bg_uprava.png';
arrayOfImages[33] = path+'slide4/btn-znovu.png';
arrayOfImages[34] = path+'slide4/point_off.png';
arrayOfImages[35] = path+'slide4/point_on.png';
arrayOfImages[36] = path+'slide4/pozadi_kvizy.jpg';
arrayOfImages[37] = path+'slide4/pozadi-menu.png';
arrayOfImages[38] = path+'slide21/bg_uprava.png';
arrayOfImages[39] = path+'slide21/slide_label21_1.jpg';
arrayOfImages[40] = path+'slide21/slide_label21_2.jpg';
arrayOfImages[41] = path+'slide21/slide_label21_3.jpg';
arrayOfImages[42] = path+'slide21/slide_label21_4.jpg';
arrayOfImages[43] = path+'slide21/slide_label21_5.jpg';
arrayOfImages[44] = path+'slide21/slide_label21_6.jpg';
arrayOfImages[45] = path+'slide21/slide_label21_7.jpg';
arrayOfImages[46] = path+'slide21/uprava_baner.png';
arrayOfImages[47] = path+'slide22/bg_cistirna.png';
arrayOfImages[48] = path+'slide22/cistirna_baner.png';
arrayOfImages[49] = path+'slide22/mapa_baner.png';
arrayOfImages[50] = path+'slide22/slide_label22_1.jpg';
arrayOfImages[51] = path+'slide22/slide_label22_2.jpg';
arrayOfImages[52] = path+'slide22/slide_label22_3.jpg';
arrayOfImages[53] = path+'slide22/slide_label22_4.jpg';
arrayOfImages[54] = path+'slide22/slide_label22_5.jpg';
arrayOfImages[55] = path+'slide22/slide_label22_6.jpg';
arrayOfImages[56] = path+'slide22/slide_label22_7.jpg';
arrayOfImages[57] = path+'slide22/slide_label22_8.jpg';
arrayOfImages[58] = path+'slide22/slide_label22_9.jpg';
arrayOfImages[59] = path+'bg-system.png';
arrayOfImages[60] = path+'bottom-arrow-left.png';
arrayOfImages[61] = path+'bottom-arrow-right.png';
arrayOfImages[62] = path+'help.png';
arrayOfImages[63] = path+'help-box1.png';
arrayOfImages[64] = path+'help-close.png';
arrayOfImages[65] = path+'help-footer.png';
arrayOfImages[66] = path+'help-move.png';
arrayOfImages[67] = path+'help-navrat.png';
arrayOfImages[68] = path+'icon-kapka.png';
arrayOfImages[69] = path+'icon-kapka-small.png';
arrayOfImages[70] = path+'ikon-kapka-help.png';
arrayOfImages[71] = path+'kapka_spustit_znovu.png';
arrayOfImages[72] = path+'kapkaBig.png';
arrayOfImages[73] = path+'loader_sprites.png';
arrayOfImages[74] = path+'logo_newslab.png';
arrayOfImages[75] = path+'look-foto.png';
arrayOfImages[76] = path+'menu-listy-sipka.png';
arrayOfImages[77] = path+'menu-sipka.png';
arrayOfImages[78] = path+'navrat.png';
arrayOfImages[79] = path+'navrat-slide1.png';
arrayOfImages[80] = path+'slide3/kapka_spustit_znovu.png';
arrayOfImages[81] = path+'slide3/otaznik.png';
arrayOfImages[82] = path+'slide3/papir.png';
arrayOfImages[83] = path+'slide3/point_off.png';
arrayOfImages[84] = path+'slide3/point_on.png';
arrayOfImages[85] = path+'slide3/pozadi_listy.jpg';
arrayOfImages[86] = path+'slide3/sipka-leva.png';
arrayOfImages[87] = path+'slide3/sipka-prava.png';
arrayOfImages[88] = path+'slide3/start-btn.png';
arrayOfImages[89] = path+'slide3/uvod-I.png';
arrayOfImages[90] = path+'slide3/uvod-II.png';
arrayOfImages[91] = path+'slide3/uvod-III.png';
arrayOfImages[92] = path+'slide3/uvod-IV.png';
arrayOfImages[93] = path+'slide3/uvod-V.png';
arrayOfImages[94] = path+'slide3/uvod-VI.png';
arrayOfImages[95] = path+'slide3/uvod-VII.png';
arrayOfImages[96] = path+'slide3/uvod-VIII.png';
arrayOfImages[97] = path+'slide3/uvod-IX.png';
arrayOfImages[98] = path+'slide3/uvod-X.png';
arrayOfImages[99] = path+'slide3/uvod-XI.png';
arrayOfImages[100] = path+'slide3/uvod-XII.png';
arrayOfImages[101] = path+'slide3/uvod-XIII.png';
arrayOfImages[102] = path+'slide3/list1/ot_1_1.png';
arrayOfImages[103] = path+'slide3/list1/ot_1_2.png';
arrayOfImages[104] = path+'slide3/list1/ot_1_3.png';
arrayOfImages[105] = path+'slide3/list1/ot_1_4.png';
arrayOfImages[106] = path+'slide3/list1/ot_1_5.png';
arrayOfImages[107] = path+'slide3/list1/ot_1_6.png';
arrayOfImages[108] = path+'slide3/list1/ot_1_7.png';
arrayOfImages[109] = path+'slide3/list1/ot_2_1.png';
arrayOfImages[110] = path+'slide3/list2/ot_2_1.png';
arrayOfImages[111] = path+'slide3/list2/ot_2_2.png';
arrayOfImages[112] = path+'slide3/list2/ot_2_3.png';
arrayOfImages[113] = path+'slide3/list2/ot_2_4.png';
arrayOfImages[114] = path+'slide3/list2/ot_2_5.png';
arrayOfImages[115] = path+'slide3/list2/ot_2_6.png';
arrayOfImages[116] = path+'slide3/list2/ot_2_7.png';
arrayOfImages[117] = path+'slide3/list3/ot_3_1.png';
arrayOfImages[118] = path+'slide3/list3/ot_3_2.png';
arrayOfImages[119] = path+'slide3/list3/ot_3_3.png';
arrayOfImages[120] = path+'slide3/list3/ot_3_4.png';
arrayOfImages[121] = path+'slide3/list3/ot_3_5.png';
arrayOfImages[122] = path+'slide3/list4/ot_4_1.png';
arrayOfImages[123] = path+'slide3/list4/ot_4_2.png';
arrayOfImages[124] = path+'slide3/list4/ot_4_3a.png';
arrayOfImages[125] = path+'slide3/list4/ot_4_3b.png';
arrayOfImages[126] = path+'slide3/list4/ot_4_4.png';
arrayOfImages[127] = path+'slide3/list4/ot_4_5.png';
arrayOfImages[128] = path+'slide3/list4/ot_4_6.png';
arrayOfImages[129] = path+'slide3/list4/ot_4_7.png';
arrayOfImages[130] = path+'slide3/list5/ot_5_1.png';
arrayOfImages[131] = path+'slide3/list5/ot_5_2.png';
arrayOfImages[132] = path+'slide3/list5/ot_5_3.png';
arrayOfImages[133] = path+'slide3/list5/ot_5_4.png';
arrayOfImages[134] = path+'slide3/list6/ot_6_1.png';
arrayOfImages[135] = path+'slide3/list6/ot_6_2.png';
arrayOfImages[136] = path+'slide3/list7/ot_7_1.png';
arrayOfImages[137] = path+'slide3/list7/ot_7_2.png';
arrayOfImages[138] = path+'slide3/list8/ot_8_1.png';
arrayOfImages[139] = path+'slide3/list13/ot_13_4.png';
arrayOfImages[140] = path+'slide3/list8/ot_8_2.png';
arrayOfImages[141] = path+'slide3/list8/ot_8_3.png';
arrayOfImages[142] = path+'slide3/list9/ot_9_1.png';
arrayOfImages[143] = path+'slide3/list9/ot_9_2_a.png';
arrayOfImages[144] = path+'slide3/list9/ot_9_2_b.png';
arrayOfImages[145] = path+'slide3/list9/ot_9_2_c.png';
arrayOfImages[146] = path+'slide3/list9/ot_9_2_d.png';
arrayOfImages[147] = path+'slide3/list9/ot_9_2_e.png';
arrayOfImages[148] = path+'slide3/list9/ot_9_2_f.png';
arrayOfImages[149] = path+'slide3/list9/ot_9_3.png';
arrayOfImages[150] = path+'slide3/list9/ot_9_4.png';
arrayOfImages[151] = path+'slide3/list9/ot_9_5.png';
arrayOfImages[152] = path+'slide3/list10/ot_10_1.png';
arrayOfImages[153] = path+'slide3/list10/ot_10_2.png';
arrayOfImages[154] = path+'slide3/list10/ot_10_3.png';
arrayOfImages[155] = path+'slide3/list11/ot_11_1a.png';
arrayOfImages[156] = path+'slide3/list11/ot_11_1b.png';
arrayOfImages[157] = path+'slide3/list11/ot_11_2.png';
arrayOfImages[158] = path+'slide3/list11/ot_11_3.png';
arrayOfImages[159] = path+'slide3/list11/ot_11_4_a.png';
arrayOfImages[160] = path+'slide3/list11/ot_11_4_b.png';
arrayOfImages[161] = path+'slide3/list11/ot_11_4_c.png';
arrayOfImages[162] = path+'slide3/list11/ot_11_4_d.png';
arrayOfImages[163] = path+'slide3/list11/ot_11_4_e.png';
arrayOfImages[164] = path+'slide3/list11/ot_11_4_f.png';
arrayOfImages[165] = path+'slide3/list12/ot_12_1.png';
arrayOfImages[166] = path+'slide3/list12/ot_12_2.png';
arrayOfImages[167] = path+'slide3/list13/ot_13_1.png';
arrayOfImages[168] = path+'slide3/list13/ot_13_2_a.png';
arrayOfImages[169] = path+'slide3/list13/ot_13_2_b.png';
arrayOfImages[170] = path+'slide3/list13/ot_13_2_c.png';
arrayOfImages[171] = path+'slide3/list13/ot_13_2_d.png';

/* add the rest of images */

$(function(){
	var completePreload = false;
	$('#loaderImage').show();

	$.preload(arrayOfImages, 1, function(last){
		for (var i = 0; i < this.length; i++) {
			$('<img src="' + this[i] + '" alt="">').appendTo('#images');
		}
		if (last) {
			preloader = setInterval(
				function() {
					//if (Object.size(data2) == 8) {
						completePreload = true;
					//}
					if (completePreload === true) {
							stopAnimation();
							clearInterval(preloader);
							//$('.logoUp').hide();
							$('#loaderImage').hide();
              $('#preload').fadeOut(1000,"easeOutCirc");
							$('#startPage').show();
						}
				}, 1000
			);
		}
	});
});
